"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("defs", {
      children: (0, _jsxRuntime.jsx)("path", {
        d: "M7.67 7.613c.584-.48.92-1.18.92-1.914 0-1.422-1.21-2.574-2.703-2.574-1.493 0-2.703 1.152-2.703 2.574 0 .735.335 1.433.919 1.914-1.545.667-2.539 2.132-2.54 3.747 0 .285.241.515.54.515.299 0 .54-.23.54-.515 0-1.705 1.452-3.088 3.244-3.088 1.79 0 3.243 1.383 3.243 3.088 0 .285.242.515.54.515.299 0 .54-.23.54-.515-.001-1.615-.994-3.08-2.54-3.747zm-1.783-.37c-.896 0-1.622-.692-1.622-1.544 0-.853.726-1.545 1.622-1.545.895 0 1.621.692 1.621 1.545 0 .41-.17.802-.475 1.091a1.66 1.66 0 01-1.146.453zm5.264.164c.707-.757.88-1.84.444-2.764-.436-.924-1.401-1.518-2.465-1.518-.299 0-.54.23-.54.515 0 .284.241.514.54.514.895 0 1.621.692 1.621 1.545a1.532 1.532 0 01-.81 1.333.511.511 0 00-.27.432.508.508 0 00.242.443l.211.133.07.036c1.33.601 2.174 1.882 2.162 3.284 0 .285.242.515.54.515.3 0 .541-.23.541-.515.01-1.606-.856-3.101-2.286-3.953z",
        id: "user_group"
      })
    }), (0, _jsxRuntime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [(0, _jsxRuntime.jsx)("mask", {
        id: "user_group_b",
        fill: "currentColor",
        children: (0, _jsxRuntime.jsx)("use", {
          xlinkHref: "#user_group"
        })
      }), (0, _jsxRuntime.jsx)("use", {
        fill: "currentColor",
        fillRule: "nonzero",
        xlinkHref: "#user_group"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "currentColor",
        mask: "url(#user_group_b)",
        d: "M0 0h15v15H0z"
      })]
    })]
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=UserGroup.js.map